exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tripla-faq-widget[data-v-08ef6507]{transform:scaleY(0);transform-origin:center bottom;transition:all .5s ease-in-out;position:fixed;left:0;bottom:0;top:0;right:0;z-index:2147483647;background:rgba(0,0,0,.4);width:100%;height:100%}.tripla-faq-widget--show[data-v-08ef6507]{transform:scaleY(1)}.tripla-faq-widget iframe[data-v-08ef6507]{background:#fff;position:fixed;top:0;left:0;width:100%;height:100%;z-index:2147483647}.fade-enter-active[data-v-08ef6507],.fade-leave-active[data-v-08ef6507]{transition:opacity .5s ease-in-out}.fade-enter[data-v-08ef6507],.fade-leave-to[data-v-08ef6507]{opacity:0}", ""]);

// exports
